// Orçamento do mês por categoria: limite de gasto, com aviso aos 80% e quando passa.
import { useEffect, useState } from 'react';
import { Pressable, ScrollView, Text, View } from 'react-native';
import type { Financas } from '../../store/types';
import { estouros, gastosPorCategoria, numerosMes, setOrcamento } from '../../store/financas';
import { Btn, Field, Sheet } from '../ui';
import { C } from '../theme';
import { lerValor } from '../../lib/moeda';
import { t } from '../../lib/i18n';
import { CATS_ORCAMENTO, ICONE_CAT, nomeCat } from './cats';
import { ROLAGEM_TECLADO } from '../teclado';

export function OrcamentoSheet({ d, ym, aberta, fechar, cor, $ }: { d: Financas; ym: string; aberta: boolean; fechar: () => void; cor: string; $: (v: number) => string }) {
  const [txt, setTxt] = useState<Record<string, string>>({});
  useEffect(() => {
    if (aberta) setTxt(Object.fromEntries(Object.entries(d.orcamento ?? {}).map(([k, v]) => [k, String(v).replace('.', ',')])));
  }, [aberta]); // eslint-disable-line react-hooks/exhaustive-deps
  const gastos = gastosPorCategoria(numerosMes(d, ym).itens);
  function salvar() {
    for (const c of CATS_ORCAMENTO) setOrcamento(c, lerValor(txt[c] ?? '') || 0);
    fechar();
  }
  return (
    <Sheet visible={aberta} onClose={fechar} title={t('Orçamento do mês')} right={<Pressable onPress={salvar}><Text style={{ color: cor, fontWeight: '800' }}>{t('Salvar')}</Text></Pressable>}>
      <ScrollView {...ROLAGEM_TECLADO} keyboardShouldPersistTaps="handled" contentContainerStyle={{ padding: 16, gap: 10, paddingBottom: 60 }}>
        <Text style={{ color: C.sub, fontSize: 13 }}>{t('Quanto você quer gastar, no máximo, em cada categoria por mês. Deixe em branco para não controlar.')}</Text>
        {CATS_ORCAMENTO.map(c => (
          <View key={c} style={{ flexDirection: 'row', alignItems: 'center', gap: 10 }}>
            <Text style={{ fontSize: 20, width: 28 }}>{ICONE_CAT[c]}</Text>
            <View style={{ flex: 1 }}>
              <Text style={{ color: C.text }}>{nomeCat(c)}</Text>
              <Text style={{ color: C.mute, fontSize: 11 }}>{t('Gasto neste mês: {v}', { v: $(gastos.get(c) ?? 0) })}</Text>
            </View>
            <View style={{ width: 120 }}><Field value={txt[c] ?? ''} onChangeText={v => setTxt({ ...txt, [c]: v })} keyboardType="decimal-pad" placeholder={t('Sem limite')} /></View>
          </View>
        ))}
        <Btn cor={cor} label={t('Salvar')} onPress={salvar} />
      </ScrollView>
    </Sheet>
  );
}

/** Aviso no alto da tela quando alguma categoria chega a 80% ou passa do orçamento. */
export function AvisoOrcamento({ d, ym, $, abrir }: { d: Financas; ym: string; $: (v: number) => string; abrir: () => void }) {
  const lista = estouros(d, ym);
  if (!lista.length) return null;
  const passou = lista.some(e => e.pct >= 1);
  return (
    <Pressable onPress={abrir} style={{ backgroundColor: passou ? 'rgba(239,68,68,0.12)' : 'rgba(245,158,11,0.12)', borderRadius: 14, padding: 12, gap: 4 }}>
      <Text style={{ color: passou ? C.danger : C.warn, fontWeight: '800' }}>{passou ? '🚨 ' + t('Passou do orçamento') : '⚠️ ' + t('Perto do limite do orçamento')}</Text>
      {lista.map(e => <Text key={e.cat} style={{ color: C.text, fontSize: 13 }}>{ICONE_CAT[e.cat]} {nomeCat(e.cat)}: {$(e.gasto)} {t('de')} {$(e.limite)} ({Math.round(e.pct * 100)}%)</Text>)}
    </Pressable>
  );
}

/** Depois de lançar um gasto: avisa se a categoria passou de 80% ou de 100% do orçamento do mês. */
export function conferirOrcamento(d: Financas, ym: string, cat: string, $: (v: number) => string): string | null {
  const e = estouros(d, ym).find(x => x.cat === cat);
  if (!e) return null;
  return e.pct >= 1 ? t('{c} passou do orçamento: {g} de {l}.', { c: nomeCat(cat), g: $(e.gasto), l: $(e.limite) })
    : t('{c} chegou a {p}% do orçamento ({g} de {l}).', { c: nomeCat(cat), p: Math.round(e.pct * 100), g: $(e.gasto), l: $(e.limite) });
}
